export enum WeekMealStatuses {
  Active = 'active',
  Inactive = 'inactive',
  NeverEnrolled = 'never-enrolled',
}
